/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationMetadata } from './ConversationMetadata';
import {
    ConversationMetadataFromJSON,
    ConversationMetadataFromJSONTyped,
    ConversationMetadataToJSON,
    ConversationMetadataToJSONTyped,
} from './ConversationMetadata';
import type { McpTool } from './McpTool';
import {
    McpToolFromJSON,
    McpToolFromJSONTyped,
    McpToolToJSON,
    McpToolToJSONTyped,
} from './McpTool';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './Message';

/**
 * Model for chat requests.
 * @export
 * @interface ChatRequest
 */
export interface ChatRequest {
    /**
     * 
     * @type {Array<Message>}
     * @memberof ChatRequest
     */
    messages: Array<Message>;
    /**
     * 
     * @type {string}
     * @memberof ChatRequest
     */
    conversationId: string;
    /**
     * 
     * @type {number}
     * @memberof ChatRequest
     */
    uiComponentVersion: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatRequest
     */
    instanceIds?: Array<string> | null;
    /**
     * 
     * @type {ConversationMetadata}
     * @memberof ChatRequest
     */
    conversationMetadata?: ConversationMetadata | null;
    /**
     * 
     * @type {string}
     * @memberof ChatRequest
     */
    agentSelected?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatRequest
     */
    source?: ChatRequestSourceEnum;
    /**
     * 
     * @type {Array<McpTool>}
     * @memberof ChatRequest
     */
    mcpTools?: Array<McpTool> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatRequest
     */
    platformVersion?: string | null;
}


/**
 * @export
 */
export const ChatRequestSourceEnum = {
    Portal: 'portal',
    ArtescaUi: 'artesca_ui',
    CustomerPortal: 'customer_portal',
    RingUi: 'ring_ui',
    AdiUi: 'adi_ui'
} as const;
export type ChatRequestSourceEnum = typeof ChatRequestSourceEnum[keyof typeof ChatRequestSourceEnum];


/**
 * Check if a given object implements the ChatRequest interface.
 */
export function instanceOfChatRequest(value: object): value is ChatRequest {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('uiComponentVersion' in value) || value['uiComponentVersion'] === undefined) return false;
    return true;
}

export function ChatRequestFromJSON(json: any): ChatRequest {
    return ChatRequestFromJSONTyped(json, false);
}

export function ChatRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'conversationId': json['conversation_id'],
        'uiComponentVersion': json['ui-component-version'],
        'instanceIds': json['instance_ids'] == null ? undefined : json['instance_ids'],
        'conversationMetadata': json['conversation_metadata'] == null ? undefined : ConversationMetadataFromJSON(json['conversation_metadata']),
        'agentSelected': json['agent_selected'] == null ? undefined : json['agent_selected'],
        'source': json['source'] == null ? undefined : json['source'],
        'mcpTools': json['mcp_tools'] == null ? undefined : ((json['mcp_tools'] as Array<any>).map(McpToolFromJSON)),
        'platformVersion': json['platform_version'] == null ? undefined : json['platform_version'],
    };
}

export function ChatRequestToJSON(json: any): ChatRequest {
    return ChatRequestToJSONTyped(json, false);
}

export function ChatRequestToJSONTyped(value?: ChatRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(MessageToJSON)),
        'conversation_id': value['conversationId'],
        'ui-component-version': value['uiComponentVersion'],
        'instance_ids': value['instanceIds'],
        'conversation_metadata': ConversationMetadataToJSON(value['conversationMetadata']),
        'agent_selected': value['agentSelected'],
        'source': value['source'],
        'mcp_tools': value['mcpTools'] == null ? undefined : ((value['mcpTools'] as Array<any>).map(McpToolToJSON)),
        'platform_version': value['platformVersion'],
    };
}

